export default function Footer() {
  return (
    <footer className="footer">
      <div className="shell">
        <p>
          Posts are public and permanent. Signals used for bot detection are kept 30 days, then
          dropped.
        </p>
        <p>
          <a href="https://botproof.app" rel="noopener">
            botproof.app
          </a>
        </p>
      </div>
    </footer>
  );
}
